/**
 * Redeem request dto used in backend requests
 */
export class RedeemRequestDTO {
  /**
   * @constructor
   */
  constructor(
    public resellerInfo: string,
    public familyId: number,
    public equipmentSerial?: string
  ) {}
}
